<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-4 col-sm-4">
                <div class="mt-2 mb-3">
                  <h5 class="card-title">
                    <span class="fw-normal ms-2"
                      >{{orderTotal}}</span
                    > Record(s)
                  </h5>
                </div>
              </div>
              <!-- Search and button -->
              <div class="col-md-8 col-sm-8 text-right"> 
                <div class="row justify-content-end">
                  <div class="w-auto mb-2 
                    d-flex
                    flex-wrap 
                    mt-md-0
                    gap-2
                    mb-3
                  ">
                    <a class="btn btn-secondary"
                      @click="onSearch"
                      ><feather
                        type="refresh-ccw"
                        size="16"
                        class="icon nav-icon"
                      ></feather
                      >&nbsp;&nbsp; Refresh</a
                    >
                  </div> 
                </div>
              </div>
              <div class="col-md-4 ta-right" style="padding-right: 0px;">
                <b-form-group description="Search Keyword">
                  <form class="d-flex" @submit.prevent="onSearch('reset')">
                    <b-form-group id="input-group-3" label-for="input-3">
                      <b-form-select
                        class="form-select rounded-0 rounded-start shadow-none w-auto"
                        id="input-3"
                        v-model="searchValue.searchField"
                        :options="searchOptions"
                      ></b-form-select>
                    </b-form-group>

                    <b-input-group>
                      <b-form-input
                        class="rounded-0"
                        v-model="searchValue.search"
                      ></b-form-input>
                    </b-input-group>
                  </form>
                </b-form-group>
              </div>
              <div class="col-md-3 ta-right">                
                <div class="row">                    
                  <div class="col-md-6 ta-right" style="padding-right: 0px;">
                    <b-form-group label-for="reward-status" description="Filter by E-Seller">
                      <b-form-select class="form-select rounded-0 rounded-start shadow-none"
                        id="reward-status"
                        v-model="searchValue.eseller"
                        :options="esellerList"
                      ></b-form-select>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 ta-right" style="padding-right: 0px;">
                    <b-form-group label-for="reward-status" description="Filter by status">
                      <b-form-select class="form-select rounded-0 rounded-start shadow-none"
                        id="reward-status"
                        v-model="searchValue.status"
                        :options="statusList"
                      ></b-form-select>
                    </b-form-group>
                  </div>
                </div>                
              </div>
              <div class="col-md-5">
                <div class="d-flex flex-wrap align-items-start mt-2 mt-md-0 gap-2 mb-3 ta-right ">
                  <b-form-group description="Filter by date added">
                    <flat-pickr
                      v-model="searchValue.dateRange"
                      :config="rangeOptions"
                      placeholder="Select a date range"
                      class="form-control"
                      style="width: fit-content"
                    ></flat-pickr>
                  </b-form-group>
                  <a class="btn btn-primary h-fit" @click="onSearch('reset')">
                    <i class='bx bx-search bx-fw'></i>Search
                  </a>
                  <a href="javascript:void(0);" class="btn btn-primary me-2" @click="onExport">
                    <i class="uil uil-export me-1"></i>Export
                  </a>
                </div>
              </div>
            </div>
            <!---end of filter/search-->

            <div class="table-responsive">
              <div class="table align-middle table-nowrap text-capitalize">
                <b-table
                  :items="orderList"
                  :fields="fields"
                  responsive="sm"
                  :current-page="searchValue.page"
                  :sort-by.sync="searchValue.sort"
                  :sort-desc.sync="searchValue.orderDesc"
                  class="table-check"
                  @sort-changed="tableSort"
                >
                  <template #cell(order_id)="data">
                    {{ data.item.referenceNumber}}
                  </template>
                  <template #cell(seller_name)="data">
                    {{ esellerName(data.item.brandId) }}
                  </template>
                  <template #cell(customer_name)="data">
                    {{ data.item.customerName }}
                  </template>
                  <template #cell(mobile_number)="data">
                    {{ data.item.customerContactNumber }}
                  </template>
                  <template #cell(payment_method)="data">
                    {{ data.item.paymentMethod }}
                  </template>
                  <template #cell(amount)="data">
                    <p class="text-body text-end m-0">
                      PHP {{ data.item.total | toCurrency }}
                    </p>
                  </template>
                  <template #cell(street)="data">
                    {{ data.item.customerBillingStreet }}
                  </template>
                  <template #cell(barangay)="data">
                    {{ data.item.customerBillingBarangay }}
                  </template>
                  <template #cell(city)="data">
                    {{ data.item.customerBillingCity }}
                  </template>
                  <template #cell(province)="data">
                    {{ data.item.customerBillingProvince }}
                  </template>
                  <template #cell(date_ordered)="data">
                    {{ data.item.dateOrdered | formatDate }}
                  </template>
                  <template #cell(date_delivered)="data">
                    <span v-if="data.item.status == 'completed'">
                      {{ data.item.dateDelivered | formatDate }}
                    </span>
                  </template>
                  <template #cell(status)="data">
                    {{ data.item.status }}
                  </template>
                </b-table>
              </div>
            </div>
            <!-- end table responsive -->

            <div class="row g-0 text-center" v-if="orderTotal == 0">
              <span>No data to display.</span>
            </div>

            <div class="row" v-if="orderTotal > 0">
              <div class="col">
                <div class="form-group row pull-left" v-if="orderTotal != 0 && orderTotal > searchValue.rows">
                  <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                  <div class="col-sm-6">
                    <b-form-group label-for="display-record">
                      <b-form-select class="form-select shadow-none w-fit"
                        id="display-record"
                        v-model="searchValue.rows"
                        :options="pageOptions"
                        @change="onDisplayChange()"
                      ></b-form-select>
                    </b-form-group>
                  </div>
                </div>
                <div
                  class="
                    dataTables_paginate
                    paging_simple_numbers
                    float-end
                  "
                >
                  <b-pagination
                    v-if="orderTotal != 0 && orderTotal > searchValue.rows"
                    class="pagination-rounded"
                    v-model="searchValue.page"
                    :total-rows="orderTotal"
                    @input="onSearch()"
                    :per-page="searchValue.rows"
                  ></b-pagination>
                </div>
              </div>
            </div>
            <!--end of pagination-->

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { layoutMethods,esellerMethods,exportMethods,erpFixMessages } from '@/state/helpers';
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Swal from "sweetalert2";

export default {
  components: {
    flatPickr,
  },
  data(){
    return {
      pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      searchValue: {
        rows: 10,
        page: 1,
        searchField: null,
        search: "",
        dateRange: null,
        sort: 'id',
        orderDesc: true,
        status: null,
        eseller: null,
      },
      searchOptions: [
        {text: 'Search All', value:null},
        {text: 'Order ID', value:'order_id'},
        {text: 'Customer Name', value:'customer_name'},
        {text: 'Seller Name', value:'seller_name'},
        {text: 'Address', value:'customer_address'}
      ],
      fields: [
        {key: "order_id",sortable: true},
        {key: "seller_name",sortable: false},
        {key: "customer_name",sortable: true},
        {key: "mobile_number",sortable: true},
        {key: "payment_method",sortable: true},
        {key: "amount",sortable: true},
        {key: "street",sortable: true},
        {key: "barangay",sortable: true},
        {key: "city",sortable: true},
        {key: "province",sortable: true},
        {key: "date_ordered",sortable: true},
        {key: "date_delivered",sortable: true},
        {key: "status",sortable: true}
      ],
      rangeOptions: {
        mode: "range",
      },
      orderList:[],
      orderTotal: 0,
      statusList: [
        { text: 'All', value: null },
        { text: 'To Ship', value: 'toShip'},
        { text: 'Packed', value: 'packed'},
        { text: 'Shipped', value: 'shipped'},
        { text: 'Delivered', value: 'delivered'},
        { text: 'Completed', value: 'completed'},
        { text: 'Cancelled', value: 'cancelled'},
      ],
      esellerList:[]
    }
  },
  methods: {
    ...layoutMethods,
    ...esellerMethods,
    ...exportMethods,
    async onSearch(state = ''){
        // console.log("onsearch"+state);
        if(state == 'reset'){
          this.searchValue.page = 1;
        }
        await this.esellerOrders({
          action: "list",
          body:this.searchValue
        })
        .then((res) => {
          // console.log("esellerOrders RES:",JSON.stringify(res));
          this.orderList = res.rows;
          this.orderTotal = res.pageInfo.total;
        })
        .catch(function(error) {
          console.log("esellerOrders ERR:",JSON.stringify(error));
        });
    },
    async getESellers(){
        await this.esellerOrders({
          action: "brands",
          body:{}
        })
        .then(async (res) => {
          // console.log("getESellers RES:",JSON.stringify(res));
          this.esellerList = res.rows;
          await this.onSearch();
        })
        .catch(function(error) {
          console.log("getESellers ERR:",JSON.stringify(error));
        });
    },
    tableSort(ctx){//context
      this.searchValue.sort = ctx.sortBy;
      this.searchValue.orderDesc = ctx.sortDesc;
      console.log(">> sorting",this.searchValue);
      this.onSearch('reset');
    },
    esellerName(id){
      for(let x of this.esellerList){
        if(x["value"] == id){
          return x["text"];
        }
      }
    },
    onDisplayChange(){
      if(
        (this.orderList.length < this.orderTotal && this.orderList.length != this.searchValue.rows) || // condition for incrementing display per page
        (this.orderList.length == this.orderTotal && this.searchValue.rows < this.orderList.length) // condition for decreasing display per page
        ){
        this.searchValue.page=1;
        this.onSearch();
      }
    },
    async onExport(){
      var self = this;
      await this.onSearch("reset").then(function(){
        console.log("check this:",self.orderTotal);
        if(self.orderTotal ==0 ){
          Swal.fire("Failed!", self.exportNullPrompt, "warning");
        }else{
          let params = Object.assign(
            {
              module: 'eseller_orders',
              email: JSON.parse(localStorage.getItem('userData')).email,
              dateRange: self.searchValue.dateRange,
              orderDesc: self.searchValue.orderDesc,
              search: self.searchValue.search,
              searchField: self.searchValue.searchField,
              sort: self.searchValue.sort,
              status: self.searchValue.status,
              eseller: self.searchValue.eseller
            });
          
          self.exportReport(params)
            .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
            .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
        }
      });
    }
  },
  computed: {
    ...erpFixMessages
  },
  mounted(){
    this.changeTitle({title: 'E-Seller Orders'});
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home'}},
        { text: 'E-Seller', to: { name: 'ESeller'} },
        { text: 'Orders', to: { name: 'ESeller Orders'} }
      ]
    });
    this.getESellers();
  }
}
</script>

<style>
</style>